import { cn } from "@replohq/lattice/utils/cn";

type ReploLogoProps = {
  className?: string;
};

export function ReploLogo({ className }: ReploLogoProps) {
  return (
    <div
      className={cn(
        "relative z-10 flex size-16 shrink-0 items-center justify-center rounded-2xl border-0.5 border-border bg-white p-2 shadow-xs",
        className,
      )}
    >
      <svg
        role="img"
        aria-label="Replo logo"
        className="size-full"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="8" fill="black" />
        <rect
          x="0.208333"
          y="0.208333"
          width="39.5833"
          height="39.5833"
          rx="7.79167"
          stroke="#CBD5E1"
          strokeOpacity="0.5"
          strokeWidth="0.416667"
        />
        <path d={REPLO_GLYPH_PATH} fill="var(--color-brand-seashell)" />
      </svg>
    </div>
  );
}

/** The glyph alone in `currentColor`, for dark surfaces where the black tile would read as a stray square. */
export function ReploLogoGlyph({ className }: ReploLogoProps) {
  return (
    <svg
      role="img"
      aria-label="Replo logo"
      className={cn("size-10 shrink-0", className)}
      viewBox="9.84 10 20.32 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d={REPLO_GLYPH_PATH} fill="currentColor" />
    </svg>
  );
}

const REPLO_GLYPH_PATH =
  "M10.922 30H15.7728C16.3686 30 16.8508 29.5178 16.8508 28.922V25.1771C16.8508 24.922 17.049 24.7228 17.305 24.7228C17.5033 24.7228 17.7025 24.8644 17.7593 25.0635C18.9508 28.8085 23.0644 29.9712 26.1279 29.9712H29.0779C29.6736 29.9712 30.1558 29.489 30.1558 28.8932V24.0135C30.1558 23.4178 29.6736 22.9356 29.0779 22.9356H24.8228C24.3406 22.9356 24.1135 22.3686 24.4542 22.0279L29.1635 17.3186C29.5889 16.8932 29.8161 16.3254 29.8161 15.7296V11.078C29.8161 10.4822 29.3339 10 28.7381 10H24.0576C23.4907 10 22.9229 10.2271 22.4974 10.6525L17.7881 15.3619C17.4474 15.7026 16.8517 15.4466 16.8517 14.9644V11.078C16.8517 10.4822 16.3695 10 15.7737 10H11.177C10.5813 10 10.0991 10.4822 10.0991 11.078V15.6449C10.0991 16.2406 10.5813 16.7228 11.177 16.7228H15.0914C15.5736 16.7228 15.8007 17.3186 15.46 17.6593L12.9634 19.9856C11.1491 21.6881 9.84399 24.0703 9.84399 26.5669V28.9211C9.84399 29.5169 10.3262 29.9991 10.922 29.9991V30ZM20.7092 23.1347C19.3762 23.1068 18.1847 23.2195 17.3339 22.6237C16.511 21.9144 16.6534 20.6949 16.5966 19.6737C16.6245 18.6525 16.5398 17.3195 17.2203 16.6381C17.9008 15.9567 19.2347 15.9856 20.227 16.0144C21.2771 16.0712 22.4965 15.9297 23.2059 16.7517C23.7728 17.6025 23.6601 18.7941 23.6881 20.1271C23.6601 20.95 23.6881 21.8855 23.1211 22.5101L23.0644 22.5669C22.4686 23.1059 21.5042 23.078 20.7102 23.1338L20.7092 23.1347Z";
